import {AxiosPromise} from "axios";
import {AxiosClientFactory} from '../../../common/helpers/AxiosClientFactory';
import {AdditionalInformation} from "../../../common/models/AdditionalInformation";

export const getAdditionalInformation = (applicantId: number | string): AxiosPromise<AdditionalInformation[]> => {
    return AxiosClientFactory
        .getInstance()
        .get<AdditionalInformation[]>(`/api/applicants/${applicantId}/additionalInformation`);
};
